import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from  'vuex-along';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';


Vue.use(Vuex)

export default new Vuex.Store({
    namespaced: true,  //多出的一行
    state,
    mutations,
    actions,
    getters,
    plugins: [vuexAlong({
        name:"vuex-along",
        local:false,
        session:false
    })]
})



// WEBPACK FOOTER //
// ./src/views/pc/store/index.js